import { i18n } from '../../i18n';
import { request } from 'beans-admin-plugin';



export const filterColumnsHash = {
  title_cont: {
    label: i18n.t('product.title'),
    renderCell: {
      component: 'input'
    }
  },
  category_id_eq: {
    label: i18n.t('product.category'),
    renderCell: {
      component: 'select',
      props: {
        clearable: true,
        xRemotePreload: async () => {
          const { data } = await request.get('/categories', { params: { per_page: 100 } });
          return data.map(item => ({ value: item.id, label: item.title }));
        },
        xRemoteSearch: async (keyword) => {
          const params = { title_cont: keyword };
          const { data } = await request.get('/categories', { params });
          return data.map(item => ({ value: item.id, label: item.title }));
        }
      }
    }
  },
  designer_id_eq: {
    label: i18n.t('product.designer'),
    renderCell: {
      component: 'select',
      props: {
        clearable: true,
        xRemotePreload: async () => {
          const { data } = await request.get('/designers', { params: { per_page: 100 } });
          return data.map(item => ({ value: item.id, label: item.name }));
        },
        xRemoteSearch: async (keyword) => {
          const params = { name_cont: keyword };
          const { data } = await request.get('/designers', { params });
          return data.map(item => ({ value: item.id, label: item.name }));
        }
      }
    }
  },
}

export const columnsHash = {
  id: {
    label: i18n.t('product.id'),
    width: 80,
  },
  desc: {
    label: i18n.t('product.desc'),
  },
  design_time: {
    label: i18n.t('product.designTime'),
  },
  title: {
    label: i18n.t('product.title'),
  },
  category_id: {
    label: i18n.t('product.category'),
    renderCell: (h, { props: { scope: { row } } }) => {
      if (!row.category) {
        return <span>/</span>
      }
      return <bean-link keepNode to={{ name: 'categories.show', params: { id: row.category_id } }}>{row.category.title}</bean-link>
    },
  },
  designer_id: {
    label: i18n.t('product.designer'),
    renderCell: (h, { props: { scope: { row } } }) => {
      if (!row.designer) {
        return <span>/</span>
      }
      return <bean-link keepNode to={{ name: 'designers.show', params: { id: row.designer_id } }}>{row.designer.name}</bean-link>
    },
  },
  related_product_ids: {
    label: i18n.t('product.relatedProductIds'),
  },
  created_at: {
    label: i18n.t('product.createdAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  published_at: {
    label: i18n.t('product.publishedAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  updated_at: {
    label: i18n.t('product.updatedAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  cover: {
    label: i18n.t('product.cover'),
    width: 120,
    renderCell: 'storageAttachment',
  },
  share_image: {
    label: i18n.t('product.shareImage'),
    width: 120,
    renderCell: 'storageAttachment',
  },
  wxacode: {
    label: i18n.t('product.wxacode'),
    width: 120,
    renderCell: 'storageAttachment',
  },
  images: {
    label: i18n.t('product.images'),
    renderCell: 'storageAttachment',
  },
}

export const formColumnsHash = {
  desc: {
    label: i18n.t('product.desc'),
    renderCell: {
      component: 'input',
    },
  },
  design_time: {
    label: i18n.t('product.designTime'),
    renderCell: {
      required: true,
      component: 'input',
    },
  },
  title: {
    label: i18n.t('product.title'),
    renderCell: {
      required: true,
      component: 'input',
    },
  },
  category_id: {
    label: i18n.t('product.category'),
    renderCell: {
      required: true,
      component: 'select',
      props: {
        xRemotePreload: async () => {
          const { data } = await request.get('/categories', { params: { per_page: 100 } });
          return data.map(item => ({ value: item.id, label: item.title }));
        },
        xRemoteSearch: async (keyword) => {
          const params = { title_cont: keyword };
          const { data } = await request.get('/categories', { params });
          return data.map(item => ({ value: item.id, label: item.title }));
        }
      }
    }
  },
  designer_id: {
    label: i18n.t('product.designer'),
    renderCell: {
      required: true,
      component: 'select',
      props: {
        xRemotePreload: async () => {
          const { data } = await request.get('/designers', { params: { per_page: 100 } });
          return data.map(item => ({ value: item.id, label: item.name }));
        },
        xRemoteSearch: async (keyword) => {
          const params = { name_cont: keyword };
          const { data } = await request.get('/designers', { params });
          return data.map(item => ({ value: item.id, label: item.name }));
        }
      }
    }
  },
  related_product_ids: {
    label: i18n.t('product.relatedProductIds'),
    renderCell: {
      component: 'input',
      props: {
        type: 'number'
      },
    },
  },
  cover: {
    label: i18n.t('product.cover'),
    width: 120,
    renderCell: {
      required: true,
      component: 'upload',
    }
  },
  share_image: {
    label: i18n.t('product.shareImage'),
    width: 120,
    renderCell: {
      component: 'upload',
    }
  },
  images: {
    label: i18n.t('product.images'),
    renderCell: {
      required: true,
      component: 'upload',
    }
  },
}
